// ...existing code...
import React from "react";
import { Table, Tag, Select } from "antd";
import moment from "moment";
import { useHistory } from "react-router-dom";

const Inspections = () => {
    const [inspections, setInspections] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [userCategories, setUserCategories] = React.useState([]);
    const [viewType, setViewType] = React.useState("ALL");

    const history = useHistory();

    React.useEffect(() => {
        fetchAllInspections();
        fetchUserCategories();
    }, []);

    const column = [
        { title: "Visit Code", dataIndex: "visitCode", key: "visitCode" },
        { title: "Branch Name", dataIndex: "siteName", key: "siteName" },
        {
            title: "Status", dataIndex: "visitStatus", key: "visitStatus",
            render: (text, record) => record?.visitStatus?.name?.trim() === 'Pending' ? <Tag color="orange">{record.visitStatus.name}</Tag> :
                record?.visitStatus?.name?.trim() === 'Complete' ? <Tag color="green">{record.visitStatus.name}</Tag> :
                    record?.visitStatus?.name?.trim() === 'In Progress' ? <Tag color="blue">{record.visitStatus.name}</Tag> :
                        record?.visitStatus?.name?.trim() === 'Cancelled' ? <Tag color="red">{record.visitStatus.name}</Tag> :
                            record?.visitStatus?.name?.trim() === 'On Hold' ?
                                <Tag color="blue">{record.visitStatus.name}</Tag> : "N/A"
        },
        { title: "Created By", dataIndex: "userName", key: "userName" },
        {
            title: "Created On", dataIndex: "createdOn", key: "createdOn",
            render: (text) => text ? new Date(text).toLocaleString() : "N/A"
        },
        {
            title: "Updated On", dataIndex: "updatedOn", key: "updatedOn",
            render: (text) => text ? new Date(text).toLocaleString() : "N/A"
        },

    ]


    const fetchInspections = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append('pageNo', 0);
        formData.append('recodesPerPage', 100);
        const headers = {
            "cache-control": "no-cache",
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
            "logged-user-email": localStorage.getItem("logged_user_email"),
            // "userId": localStorage.getItem("userId")
            "userId": "1214" // Hardcoded for testing purposes
        };
        try {
            const response = await fetch('https://dnsuatapi.eimsky.com/dataCollectionService/view/myJobs', {
                method: 'POST',
                headers,
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            // backend response shape: { pageCount: 1, data: [ ... ] }
            const list = Array.isArray(json?.data) ? json.data : [];
            setInspections(list);
            console.log('Inspections Data:', list);
        } catch (error) {
            console.error('Error fetching inspections:', error);
            setInspections([]);
        }
        setLoading(false);
    }

    const fetchAllInspections = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append('pageNo', 0);
        formData.append('recodesPerPage', 100);

        const headers = {
            "cache-control": "no-cache",
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
            "logged-user-email": localStorage.getItem("logged_user_email"),
            // "userId": localStorage.getItem("userId")
            "userId": "1214" // Hardcoded for testing purposes
        };

        try {
            const response = await fetch('https://dnsuatapi.eimsky.com/dataCollectionService/view/allJobs', {
                method: 'POST',
                headers,
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const json = await response.json();
            // backend response shape: { pageCount: 1, data: [ ... ] }
            const list = Array.isArray(json?.data) ? json.data : [];
            setInspections(list);

            console.log('Inspections Data:', list);
        } catch (error) {
            console.error('Error fetching inspections:', error);
            setInspections([]);
        }
        setLoading(false);
    }

    const fetchUserCategories = async () => {
        const headers = {
            "cache-control": "no-cache",
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
            "logged-user-email": localStorage.getItem("logged_user_email"),
            // "userId": localStorage.getItem("userId")
            "userId": "1214" // Hardcoded for testing purposes
        };
        try {
            const response = await fetch('https://dnsuatapi.eimsky.com/dataCollectionService/userPermission/getUserCategories', {
                method: 'GET',
                headers,
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            const list = Array.isArray(json) ? json : [];
            setUserCategories(list);

            console.log('User Categories:', list);
        } catch (error) {
            console.error('Error fetching user categories:', error);
            setUserCategories([]);
        }
    }



    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="page-title-box">
                        <div className="row">
                            <div className="col">
                                <h4 className="page-title">
                                    <span className="textStyles-small" style={{ fontSize: 16 }}>All Inspections</span>
                                </h4>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>Branch Inspections</span>
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript:void(0);">
                                            <span className="textStyles-small" style={{ fontSize: 12 }}>All Inspections</span>
                                        </a>
                                    </li>
                                </ol>
                            </div>
                            <div className="col-auto align-self-center">
                                <Select
                                    value={viewType}
                                    className='borderedSelect'
                                    onChange={(value) => {
                                        setViewType(value);
                                        if (value === "PENDING") {
                                            fetchInspections();
                                        } else {
                                            fetchAllInspections();
                                        }
                                    }}
                                    bordered={false}
                                    style={{ height: 38, width: '250px' }}
                                >
                                    <Select.Option className="textStyles-small" style={{ fontSize: 12 }} value="PENDING">Pending Inspections</Select.Option>
                                    <Select.Option className="textStyles-small" style={{ fontSize: 12 }} value="ALL">All Inspections</Select.Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Table
                dataSource={inspections}
                loading={loading}
                columns={column}
                rowKey="id"
                className="textStyles-small table-striped-rows"
                onRow={(record) => ({
                    onClick: () => window.location.href = `/summery/${record.id}`
                })}
                rowClassName={() => 'cursor-pointer'}
                pagination={{ pageSize: inspections.length > 10 ? 10 : inspections.length }}
            />
        </div>
    );
};

export default Inspections;